import { useQuery } from '@tanstack/react-query'
import { leaderboardApi } from '@api/endpoints/leaderboard'
import { LeaderboardParams } from '@api/types/leaderboard'

export function useRecentCheckins(
  adventureId: string | undefined,
  params?: Omit<LeaderboardParams, 'mode'>
) {
  return useQuery({
    queryKey: ['adventure-checkins', adventureId, params],
    queryFn: () => leaderboardApi.getLeaderboard(adventureId!, {
      ...params,
      mode: 'recent',
      timeframe: params?.timeframe ?? 'all'
    }),
    enabled: !!adventureId,
    staleTime: 60000, // 1 minute
    refetchOnWindowFocus: false,
  })
}
